import React from 'react';

function BrowserBarComponent() {
    return <div>BrowserBarComponent</div>;
}

export default BrowserBarComponent;
